module.exports = __webpack_public_path__ + "img/the-le-chi-tiet-golf-private-26072024-hình ảnh-2.57931661.jpg";